module.exports = __webpack_public_path__ + "static/img/cont35 (4).c6c0f2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (4).jpg
// module id = /sbg
// module chunks = 0